<template>
  <div class="df subscription">
    <div>
      <div class="w500 mb20">
        <div class="mb4"><span class="red">*</span>注册文案-PC：</div>
        <quillEditor
          v-model:value="popupSet4.pcText"
          style="height: 100px; width: 500px;"
          :options="editorOption"
        />
      </div>
      <div class="w500 mb20">
        <div class="mb4"><span class="red">*</span>注册文案-M：</div>
        <quillEditor
          v-model:value="popupSet4.mText"
          style="height: 100px; width: 500px;"
          :options="editorOption"
        />
      </div>
      <div class="w500 mb20">
        <div class="mb4"><span class="red">*</span>注册按钮：</div>
        <a-input
          class="w300 mb10"
          v-model:value="popupSet4.buttonText"
          placeholder="请输入"
          @change="() => inputLengthCut(popupSet4.buttonText, 'buttonText', 4)"
        />
      </div>
      <div class="w500 mb20">
        <div class="mb4"><span class="red">*</span>登录按钮：</div>
        <a-input
          class="w300 mb10"
          v-model:value="popupSet4.buttonTextTwo"
          placeholder="请输入"
          @change="() => inputLengthCut(popupSet4.buttonText, 'buttonText', 4)"
        />
      </div>
      <div class="w500 mb20">
        <div class="mb4"><span class="red">*</span>图片：</div>
        <div class="df">
          <div class="mr20">
            <div class="w120 h120 mb10 pr">
              <a-upload-dragger
                :fileList="[]"
                :show-upload-list="false"
                name="file"
                :multiple="true"
                :customRequest="e => upload(e, 4, 'pc')"
                :accept="'.png,.jpg,.jpeg,.gif'"
                :headers="uploadHeaders"
              >
                <div v-if="['', null].includes(popupSet4.pcImgUrl)">
                  <div
                    class="w120 h120 tac"
                    style="color: #666666; font-size: 40px; line-height: 120px;"
                  >
                    <PictureOutlined />
                  </div>
                </div>
              </a-upload-dragger>
              <div
                v-if="!['', null].includes(popupSet4.pcImgUrl)"
                class="h120 pa l0 t0 sidebarContentBg"
                :style="
                  `width: 120px; background: url('${popupSet4.pcImgUrl}') center center/ cover no-repeat;`
                "
              >
                <div class="hover">
                  <EyeOutlined
                    @click="() => changeVisiblePic(true, popupSet4.pcImgUrl)"
                  />
                  &nbsp;&nbsp;
                  <DeleteOutlined @click="popupSet4.pcImgUrl = null" />
                </div>
              </div>
            </div>
            <div class="tac">PC端(三倍图)</div>
            <div class="tac">1170 × 1560</div>
            <MaterialSelectionListModal
              style="margin: 10px"
              @submit="val => handleSubmit(val, 4, 'pc')"
              :validateImageOrVideoArea="['390*520']"
              :validateImageOrVideoFormatAndSizeByMB="{
                jpg: 0.5,
                png: 0.5,
                gif: 10,
                jpeg: 0.5,
                'image/jpeg': 0.5,
                'image/png': 0.5,
                'image/gif': 10,
                'image/jpg': 0.5
              }"
              :fileterResourceType="1"
              :siteId="Number(queryParams?.siteId)"
              :terminalId="Number(queryParams?.terminalId)"
              :subTerminalId="Number(queryParams?.terminalId)"
            />
          </div>
          <div>
            <div class="w120 h120 mb10 pr">
              <a-upload-dragger
                :fileList="[]"
                :show-upload-list="false"
                name="file"
                :multiple="true"
                :customRequest="e => upload(e, 4, 'm')"
                :accept="'.png,.jpg,.jpeg,.gif'"
                :headers="uploadHeaders"
              >
                <div v-if="['', null].includes(popupSet4.mImgUrl)">
                  <div
                    class="w120 h120 tac"
                    style="color: #666666; font-size: 40px; line-height: 120px;"
                  >
                    <PictureOutlined />
                  </div>
                </div>
              </a-upload-dragger>
              <div
                v-if="!['', null].includes(popupSet4.mImgUrl)"
                class="h120 pa l0 t0 sidebarContentBg"
                :style="
                  `width: 120px; background: url('${popupSet4.mImgUrl}') center center/ cover no-repeat;`
                "
              >
                <div class="hover">
                  <EyeOutlined
                    @click="() => changeVisiblePic(true, popupSet4.mImgUrl)"
                  />
                  &nbsp;&nbsp;
                  <DeleteOutlined @click="popupSet4.mImgUrl = null" />
                </div>
              </div>
            </div>
            <div class="tac">M端(三倍图)</div>
            <div class="tac">1029 × 456</div>
            <MaterialSelectionListModal
              style="margin: 10px"
              @submit="val => handleSubmit(val, 4, 'm')"
              :validateImageOrVideoArea="['343*152']"
              :validateImageOrVideoFormatAndSizeByMB="{
                jpg: 0.3,
                png: 0.3,
                gif: 10,
                jpeg: 0.3,
                'image/jpeg': 0.3,
                'image/png': 0.3,
                'image/gif': 10,
                'image/jpg': 0.3
              }"
              :fileterResourceType="1"
              :siteId="Number(queryParams?.siteId)"
              :terminalId="Number(queryParams?.terminalId)"
              :subTerminalId="2"
            />
          </div>
        </div>
      </div>
      <div class="w500 mb20 mt20">
        <div class="mb4">是否展示偏好：</div>
        <a-radio-group
          name="radioGroup"
          v-model:value="popupSet4.showPersonalPreference"
        >
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </div>
    </div>
    <div class="EditContainerRight">
      <div class="checkPicTabs mb20">
        <div
          :class="`checkPicTab ${checkPic === 1 ? 'check' : ''}`"
          @click="() => checkPicChange(1)"
        >
          PC端
        </div>
        <div
          :class="`checkPicTab ${checkPic === 2 ? 'check' : ''}`"
          @click="() => checkPicChange(2)"
        >
          M端
        </div>
      </div>
      <div
        class="pic checkPics"
        :style="
          `background: url(${
            checkPic === 1
              ? popupSet4.showPersonalPreference
                ? pc2
                : pc1
              : popupSet4.showPersonalPreference
              ? m2
              : m1
          }) center top/contain no-repeat;`
        "
      ></div>
    </div>
  </div>
</template>
<script>
import { quillEditor } from 'vue3-quill'
import { toRefs, inject, reactive } from 'vue'
import {
  EyeOutlined,
  PictureOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
export default {
  components: {
    quillEditor,
    DeleteOutlined,
    EyeOutlined,
    PictureOutlined
  },
  setup() {
    const state = reactive({
      checkPicChange: (checkPic = 1) => {
        state.checkPic = checkPic
        console.log('state.check ', state.check)
      },
      checkPic: 1
    })
    return {
      pc1:
        'https://cdn-image.kapeixi.cn/web/6accd800-cb61-4d84-a674-b9b22e35376d/RPC-01.png',
      m1:
        'https://cdn-image.kapeixi.cn/web/65eb63fe-4fea-4c20-8ad0-fa272b26f057/Rm-01.png',
      pc2:
        'https://cdn-image.kapeixi.cn/web/4b5c7ea7-f784-47cc-bdba-91da969d4a0f/PC2.png',
      m2:
        'https://cdn-image.kapeixi.cn/web/b3f358c8-373b-4fd4-92c9-29e3d7e8bf3a/M2.png',
      ...toRefs(inject('initState')),
      editorOption: {
        placeholder: '请输入',
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [
              {
                size: [
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '28px',
                  '30px',
                  '32px',
                  '34px',
                  '36px',
                  '38px',
                  '40px'
                ]
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      }
    }
  }
}
</script>
<style scoped>
.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.checkPics {
  height: 560px;
}

.sidebarContentBg .hover {
  width: 120px;
  height: 120px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 120px;
  background: rgba(0, 0, 0, 0.3);
}

.sidebarContentBg:hover .hover {
  display: block;
}
</style>
<style>
.subscription .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
</style>
